'use strict';

var BaseStaticView = require('actions/shared/AbstractStaticView');
var tpl = require('actions/vpn/auth/static.html');
var twig = require('twig').twig;

/**
 * Renders a text-only version of the "VPN Authentication" component.
 */
module.exports = BaseStaticView.extend({
  /**
   * @name actions/vpn/auth/StaticView#model
   * @type {actions/vpn/auth/EditVpnAuth
   */

  template: twig({data: tpl}),
});
